import angular from 'angular';
import copy from 'app/constants';
import {
  ssDialogService,
  loaderService,
  riskDataService,
  riskSharedModelService,
} from 'app/services';
import { alerts, editRiskTypeDialog } from 'app/components/global';
import controller from './settings-dialog.controller';
import template from './settings-dialog.html';
import nameMessagesTpl from './name.messages.html';
import controlWeightMessagesTpl from './control.alert-weight.messages.html';
import riskType from '../riskType';

require('ng-file-upload');

const ngFileUpload = 'ngFileUpload';
require('ng-file-upload/dist/ng-file-upload-shim');// Loads itself

export class dialogService {
  getOptions($event, {
    riskTypes,
    riskTypeList,
  }) {
    return {
      controller,
      controllerAs: 'settingRiskDialogVM',
      locals: {
        riskTypes,
        riskTypeList
      },
      escapeToClose: false,
      clickOutsideToClose: false,
      targetEvent: $event,
      template,
    };
  }
}

export default angular.module('app.components.admin.riskAdministration.settingsDialog', [
  ngFileUpload,
  ssDialogService,
  loaderService,
  riskDataService,
  riskSharedModelService,
  copy,
  alerts,
  riskType,
  editRiskTypeDialog,
])
  .service('riskSettingsDialog', dialogService)
  .run(($templateCache) => {
    $templateCache.put('name.messages.html', nameMessagesTpl);
    $templateCache.put('control.alert-weight.messages.html', controlWeightMessagesTpl);
  })
  .name;

console.log('app.components.admin.riskAdministration.settingsDialog created');
